module.exports = __webpack_public_path__ + "img/bcc004.3e5729c0.jpeg";